import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Library } from '../../../../../types/library';

/**
 * HomeLibraryCard — Presentation Component
 *
 * Home page "مكتبات معين الرقمية" card: a cover photo with a green
 * scrim, the library name, its title count and a "read more" action that
 * deep-links into the catalogue filtered by that library.
 *
 * Distinct from the stacked `app-libraries-card` used on the /libraries page.
 */
@Component({
  selector: 'app-home-library-card',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './home-library-card.component.html',
  styleUrl: './home-library-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeLibraryCardComponent {
  /** The library to display */
  @Input({ required: true }) library!: Library;

  /** Cover used when the library has no image of its own */
  @Input() fallbackImage = '';

  get imageUrl(): string {
    return this.library?.image || this.fallbackImage;
  }

  /** Number of catalogued titles, or null when the API did not supply one */
  get titlesCount(): number | null {
    const count =
      this.library?.titles_count ?? this.library?.count ?? this.library?.holdings_count;
    return typeof count === 'number' && count > 0 ? count : null;
  }
}
